/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tempForm: null,
    application: null,
    asbestosContractors: [],
    demolitionContractors: [],
    demolitionFacilities: [],
    demolitionMaterials: [],
  },
  mutations: {
    temporaryForm(state, temporaryForm) {
      state.tempForm = temporaryForm;
    },
    clearForm(state) {
      state.tempForm = null;
    },
    application(state, permitApp) {
      state.application = permitApp;
    },
    revisionSections(state, sections) {
      state.revisionSections = sections;
    },
    asbestosContractors(state, contractorArray) {
      state.asbestosContractors = contractorArray;
    },
    demolitionContractors(state, contractorArray) {
      state.demolitionContractors = contractorArray;
    },
    demolitionFacilities(state, contractorArray) {
      state.demolitionFacilities = contractorArray;
    },
    demolitionMaterials(state, contractorArray) {
      state.demolitionMaterials = contractorArray;
    },
  },
  actions: {

  },
  getters: {
    temporaryForm: state => state.tempForm,
    contractors: state => (contractorType) => {
      if (contractorType.toLowerCase() === 'asbestos') {
        return state.asbestosContractors;
      }
      return state.demolitionContractors;
    },
    facilities: state => () => state.demolitionFacilities,
    materials: state => () => state.demolitionMaterials,
  },
});
